<aside class="uc-page-feedback" [attr.aria-label]="'unifiedFunctional.feedback.regionLabel' | translate">
  <div class="uc-page-feedback__inner">
    <div *ngIf="status === 'submitted'; else feedbackForm" #confirmation class="uc-page-feedback__confirmation" role="status"
      tabindex="-1">
      <i class="fa-solid fa-circle-check" aria-hidden="true"></i>
      <p class="uc-page-feedback__thanks">{{ 'unifiedFunctional.feedback.thanks' | translate }}</p>
    </div>

    <ng-template #feedbackForm>
      <form class="uc-page-feedback__form" (ngSubmit)="submit()" novalidate>
        <div class="uc-page-feedback__row">
          <p id="uc-feedback-question" class="uc-page-feedback__question">{{ 'unifiedFunctional.feedback.question' | translate }}</p>
          <div class="uc-page-feedback__choices" role="radiogroup" aria-labelledby="uc-feedback-question">
            <button #yesButton type="button" role="radio" class="btn uc-page-feedback__choice"
              [class.is-selected]="isHelpful === true" [attr.aria-checked]="isHelpful === true"
              [tabIndex]="isHelpful === false ? -1 : 0" [disabled]="status === 'submitting'" (click)="choose(true)"
              (keydown)="onChoiceKeydown($event, [yesButton, noButton])">
              <i class="fa-regular fa-thumbs-up" aria-hidden="true"></i>
              {{ 'unifiedFunctional.feedback.yes' | translate }}
            </button>
            <button #noButton type="button" role="radio" class="btn uc-page-feedback__choice"
              [class.is-selected]="isHelpful === false" [attr.aria-checked]="isHelpful === false"
              [tabIndex]="isHelpful === false ? 0 : -1" [disabled]="status === 'submitting'" (click)="choose(false)"
              (keydown)="onChoiceKeydown($event, [yesButton, noButton])">
              <i class="fa-regular fa-thumbs-down" aria-hidden="true"></i>
              {{ 'unifiedFunctional.feedback.no' | translate }}
            </button>
          </div>
        </div>

        <div *ngIf="isHelpful !== null" class="uc-page-feedback__details">
          <label for="uc-feedback-comment" class="uc-page-feedback__label">{{ 'unifiedFunctional.feedback.comment' | translate }}</label>
          <textarea id="uc-feedback-comment" name="comment" class="form-control uc-page-feedback__comment" rows="3"
            [maxlength]="commentMax" aria-describedby="uc-feedback-counter" [(ngModel)]="comment"
            [disabled]="status === 'submitting'"></textarea>
          <p id="uc-feedback-counter" class="uc-page-feedback__counter">
            {{ 'unifiedFunctional.feedback.counter' | translate: { count: commentLength, max: commentMax } }}
          </p>

          <p *ngIf="status === 'error'" class="uc-page-feedback__error" role="alert">
            <i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i>
            {{ 'unifiedFunctional.feedback.error' | translate }}
          </p>

          <button type="submit" class="btn btn-primary uc-btn-primary uc-page-feedback__submit" [disabled]="!canSubmit">
            {{ (status === 'submitting' ? 'unifiedFunctional.feedback.submitting' : 'unifiedFunctional.feedback.submit') | translate }}
          </button>
        </div>
      </form>
    </ng-template>
  </div>
</aside>
